import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-theme__wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "modal-theme__light modal-theme__image" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Light", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "modal-theme__dark modal-theme__image" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Dark", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseHeading = _resolveComponent("BaseHeading")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_ControlButtons = _resolveComponent("ControlButtons")!
  const _component_CustomModal = _resolveComponent("CustomModal")!

  return (_openBlock(), _createBlock(_component_CustomModal, {
    id: "modal-theme",
    modalClass: "custom-modal_margin-custom is-large modal-theme",
    width: "936"
  }, {
    header: _withCtx(() => [
      _createVNode(_component_BaseHeading, { level: "1" }, {
        default: _withCtx(() => [
          _createTextVNode(" Pick a Theme to please your eyes! ")
        ]),
        _: 1
      })
    ]),
    body: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "large",
        weight: "400"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(["modal-theme__button", !_ctx.darkTheme && 'modal-theme__button--active']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClick(false)))
            }, _hoisted_4, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["modal-theme__button", _ctx.darkTheme && 'modal-theme__button--active']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClick(true)))
            }, _hoisted_7, 2)
          ])
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_ControlButtons, {
        hideCancel: true,
        onSave: _ctx.onApply
      }, {
        save: _withCtx(() => [
          _createTextVNode(" Apply ")
        ]),
        _: 1
      }, 8, ["onSave"])
    ]),
    _: 1
  }))
}